import { z } from "zod";

export namespace BizUserModels {
  /**
   * MinimalOrganizationDtoSchema
   * @type { object }
   * @property { string } id
   * @property { string } name
   * @property { string } role User role in the organization
   */
  export const MinimalOrganizationDtoSchema = z.object({ id: z.string(), name: z.string(), role: z.string() });
  export type MinimalOrganizationDto = z.infer<typeof MinimalOrganizationDtoSchema>;

  /**
   * GetCurrentUserInfoResponseDtoSchema
   * @type { object }
   * @property { string } id
   * @property { string } email
   * @property { string } firstName
   * @property { string } lastName
   * @property { string } jobTitle
   * @property { string } city
   * @property { string } state
   * @property { string } profilePictureId
   * @property { string } profilePictureUrl
   * @property { MinimalOrganizationDto } organization Current organization with user role
   */
  export const GetCurrentUserInfoResponseDtoSchema = z.object({
    id: z.string(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    jobTitle: z.string().nullable(),
    city: z.string().nullable(),
    state: z.string().nullable(),
    profilePictureId: z.string().nullable(),
    profilePictureUrl: z.string().nullish(),
    organization: MinimalOrganizationDtoSchema,
  });
  export type GetCurrentUserInfoResponseDto = z.infer<typeof GetCurrentUserInfoResponseDtoSchema>;

  /**
   * UpdateBizUserDtoSchema
   * @type { object }
   * @property { string } firstName
   * @property { string } lastName
   * @property { string } jobTitle
   * @property { string } city
   * @property { string } state
   * @property { string } profilePictureId
   */
  export const UpdateBizUserDtoSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    jobTitle: z.string(),
    city: z.string(),
    state: z.string(),
    profilePictureId: z.string(),
  });
  export type UpdateBizUserDto = z.infer<typeof UpdateBizUserDtoSchema>;
}
